export const lawyerTransformer = (data) => {
    return {
        username: data.username,
        password: data.password,
        role: 'lawyer',
        stripeSourceToken: data.paymentToken,
        profile: {
            firstName: data.firstName,
            lastName: data.lastName,
            dob: data.dateOfBirth,
            sex: data.gender,
            phone: data.countryCode + data.phone,
            email: data.email,
            lawSocietyNumber: data.lso,
            yearsOfExperience: data.yearsOfExp,
            spokenLanguages: data.spokenLanguages,
            areasOfExpertise: data.areasOfExpertise,
            firmSize: data.firmSize,
            firmAddress: {
                line1: data.address.line1,
                ...(data.address.line2 ? {line2: data.address.line2} : {}),
                city: data.address.city,
                country: data.address.country,
                region: data.address.province,
                postalCode: data.postalCode,
            }
        }
    }
}